export const config = {
  showMenu: false
}